import React from "react";

const ShopIcon = props => (

  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="20"
    fill="none"
    viewBox="0 0 23 20"
  >
    <path fill="#E5E5E5" d="M0 0H23V20H0z"></path>
    <path
      fill="#fff"
      d="M0 0H375V757H0z"
      transform="translate(-18 -199)"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M22.848-148l-11-11-11 11H-18v619h375v-619H22.848z"
      clipRule="evenodd"
    ></path>
    <g clipPath="url(#clipshop)">
      <path
        fill="#6BC13E"
        d="M17.143 12.857h-1.429v1.429h1.429v-1.429z"
      ></path>
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M7.143 12.143l-1.429 3.571M10 12.143l-1.429 3.571M14.286 19.286V7.857M20.714.714l1.429 5.715M2.143 8.571v10c0 .393.321.715.714.715H20a.716.716 0 00.714-.715v-10M.714 6.429L2.143.714M5 6.429A2.14 2.14 0 012.857 8.57 2.14 2.14 0 01.714 6.43"
      ></path>
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M9.286 6.429A2.14 2.14 0 017.143 8.57 2.14 2.14 0 015 6.43"
      ></path>
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M13.571 6.429A2.14 2.14 0 0111.43 8.57 2.14 2.14 0 019.286 6.43"
      ></path>
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M17.857 6.429a2.14 2.14 0 01-2.143 2.142 2.14 2.14 0 01-2.143-2.142"
      ></path>
      <path
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M22.143 6.429A2.14 2.14 0 0120 8.57a2.14 2.14 0 01-2.143-2.142M2.143.714h18.571"
      ></path>
    </g>
    <defs>
      <clipPath id="clipshop">
        <path fill="#fff" d="M0 0H22.857V20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ShopIcon;



// WEBPACK FOOTER //
// ./src/icons/ShopIcon.jsx